// extracted by mini-css-extract-plugin
export default {"tag":"components_tag__Dzu2u","tag__checked":"components_tag__checked__cb9SA"};